import React from 'react';
import { Bed, Stethoscope, Clock, Home, TreeDeciduous, Accessibility, Calendar, CheckCircle } from 'lucide-react';

const facts = [
  { icon: Bed, value: '40', label: 'Bed Care Home' },
  { icon: Stethoscope, value: '3', label: 'Care Types' },
  { icon: Clock, value: '24/7', label: 'Professional Support' },
  { icon: Home, value: 'Yes', label: 'En-suite Rooms Available' },
  { icon: TreeDeciduous, value: 'Yes', label: 'Garden & Outdoor Spaces' },
  { icon: Accessibility, value: 'Yes', label: 'Wheelchair Accessible' },
  { icon: Calendar, value: 'Daily', label: 'Activity Programme' },
  { icon: CheckCircle, value: 'Good', label: 'CQC Rating' },
];

const KeyFactsSection = () => {
  return (
    <section
      id="key-facts"
      className="py-20 md:py-32 bg-[#1e3a5f]"
      data-testid="key-facts-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/20 rounded-full text-[#c9a227] text-sm font-medium mb-6">
            Key Facts
          </div>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6"
           
          >
            At a Glance
          </h2>
        </div>

        {/* Facts Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {facts.map((fact, index) => {
            const IconComponent = fact.icon;
            return (
              <div
                key={fact.label}
                className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center hover:bg-white/15 transition-colors"
                data-testid={`key-fact-${index}`}
              >
                <div className="w-14 h-14 rounded-xl bg-[#c9a227]/20 flex items-center justify-center mx-auto mb-4">
                  <IconComponent className="w-7 h-7 text-[#c9a227]" />
                </div>
                <div className="text-3xl font-bold text-white mb-1">{fact.value}</div>
                <div className="text-white/70 text-sm">{fact.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default KeyFactsSection;
